import React from 'react'
import { Body1, Body3 } from '@flatsy/core/MaterialUi/Typo'
import { Grid, TextField, useTheme } from '@material-ui/core'
import WarningIcon from '@flatsy/core/Icon/Warning'
import Separator from '@flatsy/core/Layout/Separator'
import { CancellationReason } from '@flatsy/types/Applications/CancellationReason'
import i18n from '@flatsy/utils/translations'
import { ComponentProps } from './Type'
import useStyles from './Style'
import ReasonItem from './Item'

const BookingCancelReason: React.FC<ComponentProps> = ({
  agent,
  hasBookingConfirmed,
  details,
  selectedReason,
  handleDetailChange,
  handleSelection,
}) => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <Grid container direction="column">
      <Grid item>
        <Body1 fontColor={theme.palette.primary.dark}>
          {i18n.t('what_is_the_reason_for_your_withdrawal')}
        </Body1>
      </Grid>
      <Separator size="24px" />

      {hasBookingConfirmed && (
        <>
          <ReasonItem
            label={i18n.t('something_came_up_that_keeps_me_from_doing_the_tour')}
            color={theme.palette.secondary.dark}
            isSelected={selectedReason === CancellationReason.unexpectedEvent}
            handleSelect={handleSelection(CancellationReason.unexpectedEvent)}
            expandable
          >
            <div className={classes.alert}>
              <WarningIcon color={theme.palette.error.main} />
              <Body1 component="span" className={classes.alertLabel}>
                {i18n.t('your_tour_will_be_cancelled_contact_your_agent')}
                &nbsp;
                <Body3 component="span">
                  {agent.name}
                  <Body1 component="span">&nbsp;au&nbsp;</Body1>
                  {agent.phoneNumber}
                </Body3>
                &nbsp;
                {i18n.t('to_change_the_appointment_time')}
              </Body1>
            </div>
            <Separator size="16px" />
            <TextField
              name={CancellationReason.unexpectedEvent}
              variant="outlined"
              inputProps={{ maxLength: '300' }}
              placeholder={i18n.t('if_you_would_like_to_tell_us_more')}
              value={details.unexpectedEvent}
              onChange={(e) =>
                handleDetailChange(CancellationReason.unexpectedEvent, e.target.value)
              }
              className={classes.input}
            />
          </ReasonItem>
          <Separator size="16px" />
        </>
      )}

      <ReasonItem
        label={i18n.t('the_precise_location_of_the_property_does_not_suit_me')}
        color={theme.palette.secondary.dark}
        isSelected={selectedReason === CancellationReason.inconvenientLocation}
        handleSelect={handleSelection(CancellationReason.inconvenientLocation)}
        expandable
      >
        <TextField
          name={CancellationReason.inconvenientLocation}
          variant="outlined"
          inputProps={{ maxLength: '300' }}
          placeholder={i18n.t('if_you_would_like_to_tell_us_more')}
          value={details.inconvenientLocation}
          onChange={(e) =>
            handleDetailChange(CancellationReason.inconvenientLocation, e.target.value)
          }
          className={classes.input}
        />
      </ReasonItem>
      <Separator size="16px" />
      <ReasonItem
        label={i18n.t('i_found_what_i_was_looking_for_elsewhere')}
        color={theme.palette.secondary.dark}
        isSelected={selectedReason === CancellationReason.foundAnotherAsset}
        handleSelect={handleSelection(CancellationReason.foundAnotherAsset)}
        expandable
      >
        <TextField
          name={CancellationReason.foundAnotherAsset}
          variant="outlined"
          inputProps={{ maxLength: '300' }}
          placeholder={i18n.t('if_you_would_like_to_tell_us_more')}
          value={details.foundAnotherAsset}
          onChange={(e) => handleDetailChange(CancellationReason.foundAnotherAsset, e.target.value)}
          className={classes.input}
        />
      </ReasonItem>
      <Separator size="16px" />
      <ReasonItem
        label={i18n.t('one_aspect_of_the_property_is_hindering_floor_noise_orientation_etc')}
        color={theme.palette.secondary.dark}
        isSelected={selectedReason === CancellationReason.somethingOff}
        handleSelect={handleSelection(CancellationReason.somethingOff)}
        expandable
      >
        <TextField
          name={CancellationReason.somethingOff}
          variant="outlined"
          inputProps={{ maxLength: '300' }}
          placeholder={i18n.t('if_you_would_like_to_tell_us_more')}
          value={details.somethingOff}
          onChange={(e) => handleDetailChange(CancellationReason.somethingOff, e.target.value)}
          className={classes.input}
        />
      </ReasonItem>
      <Separator size="16px" />
      <ReasonItem
        label={i18n.t('this_property_does_not_appeal_to_my_partner_roommate')}
        color={theme.palette.secondary.dark}
        isSelected={selectedReason === CancellationReason.partnerRoommate}
        handleSelect={handleSelection(CancellationReason.partnerRoommate)}
        expandable
      >
        <TextField
          name={CancellationReason.partnerRoommate}
          variant="outlined"
          inputProps={{ maxLength: '300' }}
          placeholder={i18n.t('if_you_would_like_to_tell_us_more')}
          value={details.partnerRoommate}
          onChange={(e) => handleDetailChange(CancellationReason.partnerRoommate, e.target.value)}
          className={classes.input}
        />
      </ReasonItem>
    </Grid>
  )
}

export default BookingCancelReason
